import { FormDatePicker, FormInput, Loader } from "@/components";
import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useStrategicInvestment from "./useStrategicInvestment";
import { AS_ON, KPL, MBAPL, SGFL, SIPL } from "./consts";

const StrategicInvestment = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isLoadingInvestment,
    isAddPending,
    isUpdatePending,
  } = useStrategicInvestment();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      {isLoadingInvestment ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white rounded-sm px-[30px] py-[25px]">
              <h2 className="text-lg font-semibold text-primary mb-4">
                For Ostwal
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-[30px]">
                <FormDatePicker
                  name={AS_ON}
                  label="As On"
                  placeholder="Please Select"
                  error={errors[AS_ON]?.message}
                  isRequired
                />
                <FormInput
                  name={KPL}
                  control={form.control}
                  label="KPL"
                  placeholder="Please enter"
                  error={errors[KPL]?.message}
                  isRequired={requiredFields.includes(KPL)}
                  variant="float"
                />
                <FormInput
                  name={MBAPL}
                  control={form.control}
                  label="MBAPL"
                  placeholder="Please enter"
                  error={errors[MBAPL]?.message}
                  isRequired={requiredFields.includes(MBAPL)}
                  variant="float"
                />
                <FormInput
                  name={SGFL}
                  control={form.control}
                  label="SGFL"
                  placeholder="Please enter"
                  error={errors[SGFL]?.message}
                  isRequired={requiredFields.includes(SGFL)}
                  variant="float"
                />
                <FormInput
                  name={SIPL}
                  control={form.control}
                  label="SIPL"
                  placeholder="Please enter"
                  error={errors[SIPL]?.message}
                  isRequired={requiredFields.includes(SIPL)}
                  variant="float"
                />
              </div>
              <div className="flex flex-row justify-end gap-3  py-3">
                <Button
                  type="submit"
                  disabled={isAddPending || isUpdatePending}
                >
                  {isAddPending ||
                    (isUpdatePending ? <Loader variant="secondary" /> : <></>)}
                  Submit
                </Button>
              </div>
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default StrategicInvestment;
